module.exports = __webpack_public_path__ + "img/portrait-084.840da693.jpg";